import { FC } from 'react';
import styles from './styles.module.scss';
import Card from '@components/cards/card';
import Button from '@components/common/button';
import { useTranslation } from 'react-i18next';
import { ECardStatus, TCard } from '@xeppt/xeppt-sdk/types';
import Skeleton from '@components/common/skeleton';
import { useXepptCardModals } from '@hooks/modals/useXepptCardModals';

interface IProps {
    card?: TCard;
    refetchCard: () => void;
    isCardLoading?: boolean;
}

const CardDataSection: FC<IProps> = ({ card, refetchCard, isCardLoading }) => {
    const { t } = useTranslation('sections', {
        keyPrefix: 'xeppt_card.card_data'
    });
    const {
        handleOpenAddMoneyModal,
        handleActivateCard,
        handleOpenUnfreezeCard,
        handleOpenFreezeCard,
        handleOpenManageModal
    } = useXepptCardModals({ refetchCard, card });

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <div className={styles.left_content}>
                    {isCardLoading ? (
                        <Skeleton className={styles.card_skeleton} />
                    ) : (
                        card && <Card isExpiry={false} isMini isBalance={true} card={card} />
                    )}
                    <div className={styles.actions_wrapper}>
                        {card?.status === ECardStatus.ACTIVE && (
                            <div className={styles.action}>
                                <Button
                                    variant="icon-dark"
                                    leftIcon="plus"
                                    onClick={handleOpenAddMoneyModal}
                                />
                                <p>{t('add_money')}</p>
                            </div>
                        )}
                        {(card?.status === ECardStatus.WAITING_FOR_ACTIVATION ||
                            card?.status === ECardStatus.TEMPORARY_CLOSED) && (
                            <div className={`${styles.action} ${styles.second}`}>
                                <Button
                                    variant="icon-dark"
                                    leftIcon="power"
                                    onClick={handleActivateCard}
                                />
                                <p>{t('activate')}</p>
                            </div>
                        )}
                        {/*<div className={`${styles.action} ${styles.second}`}>
                            <Button
                                variant="icon-gray"
                                leftIcon="document"
                                onClick={handleOpenCardAgreementModal}
                            />
                            <p>Agreement</p>
                        </div>*/}
                        <div className={styles.action}>
                            <Button
                                variant="icon-gray"
                                leftIcon="settings"
                                onClick={() => handleOpenManageModal(card)}
                            />
                            <p>{t('manage_card')}</p>
                        </div>
                        {(card?.status === ECardStatus.ACTIVE ||
                            card?.status === ECardStatus.FREEZED) && (
                            <div className={styles.action}>
                                <Button
                                    variant="icon-gray"
                                    leftIcon={
                                        card?.status !== ECardStatus.FREEZED ? 'freeze' : 'heat'
                                    }
                                    onClick={() =>
                                        card?.status === ECardStatus.FREEZED
                                            ? handleOpenUnfreezeCard(card?.id)
                                            : handleOpenFreezeCard(card?.id)
                                    }
                                />
                                <p>
                                    {card?.status === ECardStatus.FREEZED
                                        ? 'Unfreeze card'
                                        : 'Freeze card'}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardDataSection;
